<template>
  <div class="pdt-20px" v-if="devisCommande">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionCommande.renouvellement.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-2-fullhd is-3">
            <b-field :label="$t('editionCommande.renouvellement.labelRenouvellement')"
                     custom-class="mgb-14px">
              <b-checkbox v-model="devisCommande.renouvelable"
              @input="resetReconductibleDateRenouvellementDatePreavis()">
                <p class="has-text-icon-more">
                  {{ $t('editionCommande.renouvellement.renouvelable') }}
                </p>
              </b-checkbox>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-3" v-if="devisCommande.renouvelable">
            <b-field :label="$t('editionCommande.renouvellement.labelReconduction')"
                     custom-class="mgb-14px">
              <b-checkbox v-model="devisCommande.reconductible">
                <p class="has-text-icon-more">
                  {{ $t('editionCommande.renouvellement.reconductible') }}
                </p>
              </b-checkbox>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-3" v-if="devisCommande.renouvelable">
            <b-field :label="$t('editionCommande.renouvellement.labelDateRenouvellement')"
                     class="obligatoire">
              <b-datepicker show-week-number
                            icon="calendar-today"
                            editable
                            nearby-selectable-month-days
                            v-model="devisCommande.dateRenouvellement">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-2-fullhd is-3" v-if="devisCommande.renouvelable">
            <b-field :label="$t('editionCommande.renouvellement.labelDatePreavis')"
                     class="obligatoire">
              <b-datepicker show-week-number
                            icon="calendar-today"
                            editable
                            nearby-selectable-month-days
                            :value="getDatePreavis"
                            @input="updateNotUpdateDatePreavis"
              >
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-5" v-if="devisCommande.etatRenouvellement
          === constantes.ETAT_NONRENOUVELEE && devisCommande.renouvelable">
            <b-field :label="$t('editionCommande.renouvellement.motifNonRenouvellement')">
              <b-input v-model="devisCommande.motifNonRenouvellement" type="textarea">
              </b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { ETAT_NONRENOUVELEE } from '@/configuration/devisConf';
import { REGIE } from '@/configuration/societe/societe';
import calculDatePreavis from '@/services/bodac/commande/datePreavis/calculDatePreavis';
import cloneDeep from 'lodash/cloneDeep';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    devisCommande: Object,
  },
  data() {
    return {
      constantes: {
        ETAT_NONRENOUVELEE,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    getDatePreavis() {
      const dateSave = cloneDeep(this.devisCommande.datePreavis);
      let date = calculDatePreavis(this.devisCommande,
        this.devisCommande.role === REGIE
          ? this.societeActive.delaiAdministratifVente
          : this.societeActive.delaiAdministratifAchat);
      if (this.devisCommande.notUpdateDatePreavis) {
        delete this.devisCommande.notUpdateDatePreavis;
        date = dateSave;
      }
      this.updateDatePreavis(date);
      return date;
    },
  },
  methods: {
    updateNotUpdateDatePreavis(newDatePreavis) {
      this.devisCommande.notUpdateDatePreavis = true;
      this.updateDatePreavis(newDatePreavis);
    },
    updateDatePreavis(newDatePreavis) {
      this.devisCommande.datePreavis = newDatePreavis;
    },
    resetReconductibleDateRenouvellementDatePreavis() {
      this.devisCommande.reconductible = false;
      this.devisCommande.dateRenouvellement = null;
      this.devisCommande.datePreavis = null;
    },
  },
};
</script>

<style scoped>

</style>
